import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          {contactData.title}
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          {contactData.intro}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {contactData.items.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 text-center"
            >
              <span className="inline-flex w-12 h-12 items-center justify-center rounded-full bg-accent-500/10 text-accent-400 mb-3">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-400 block mb-1">{item.label}</span>
              <span className="text-sm text-foreground-700 font-medium break-all">
                {item.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}